import { create } from 'zustand';
import { keycloak, getTokenParsed } from '../lib/keycloak';

interface User {
  id?: number;
  keycloakId: string;
  email: string;
  firstName: string;
  lastName: string;
  companyId?: number;
  roles: string[];
}

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: User | null;
  token: string | null;
  setAuthenticated: (authenticated: boolean) => void;
  setLoading: (loading: boolean) => void;
  setUser: (user: User | null) => void;
  setToken: (token: string | null) => void;
  updateFromKeycloak: () => void;
  login: () => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  isLoading: true,
  user: null,
  token: null,

  setAuthenticated: (authenticated) => set({ isAuthenticated: authenticated }),
  setLoading: (loading) => set({ isLoading: loading }),
  setUser: (user) => set({ user }),
  setToken: (token) => set({ token }),

  updateFromKeycloak: () => {
    const tokenParsed = getTokenParsed();
    if (tokenParsed && keycloak.authenticated) {
      const user: User = {
        id: tokenParsed.user_id,
        keycloakId: tokenParsed.sub || '',
        email: tokenParsed.email || '',
        firstName: tokenParsed.given_name || '',
        lastName: tokenParsed.family_name || '',
        companyId: tokenParsed.company_id,
        roles: tokenParsed.realm_access?.roles || [],
      };

      set({
        isAuthenticated: true,
        user,
        token: keycloak.token || null,
      });
    } else {
      set({
        isAuthenticated: false,
        user: null,
        token: null,
      });
    }
  },

  login: () => {
    keycloak.login();
  },

  logout: () => {
    // Ne PAS mettre à jour le state avant la redirection :
    // sinon ProtectedRoute détecte isAuthenticated=false et appelle login()
    // avant que keycloak.logout() n'ait le temps de rediriger.
    keycloak.logout({ redirectUri: window.location.origin });
  },
}));
